// @ts-nocheck

import React, { useRef } from 'react';
import styled from 'styled-components';

import { StickyMatchActionsRowContexts } from '../../constants/match';
import useMatchBetFiltersHandlerContext from '../../hooks/useMatchBetFiltersHandlerContext';
import FiltersWrapper from '../FiltersWrapper';
import MatchBetFilter from '../MatchBetFilter';
import MatchBetHotFilterContainer from '../MatchBetHotFilter/MatchBetHotFilterContainer';

const MatchBetFilterWrapper = styled(FiltersWrapper)``;

const MatchBetFilters = ({ className, filters, onFilterClick, onBackClick, context }) => {
  const filtersElementsRef = useRef([]);

  const { currentFilter } = useMatchBetFiltersHandlerContext();

  return (
    <MatchBetFilterWrapper
      onBackClick={onBackClick}
      filtersElementsRef={filtersElementsRef}
      className={className}
      hasAutoStickyBehaviour={false}
    >
      {context !== StickyMatchActionsRowContexts.LINE_UP ? <MatchBetHotFilterContainer /> : null}

      {filters.map(({ id, label, nbBets, newTag }, i) => {
        return (
          <MatchBetFilter
            key={`${id}-${context}`}
            id={id}
            label={label}
            info={nbBets}
            ref={(el) => (filtersElementsRef.current[i] = el)}
            onClick={() => onFilterClick(i)}
            isSelected={currentFilter?.id === id}
            newTag={newTag}
          />
        );
      })}
    </MatchBetFilterWrapper>
  );
};

export default React.memo(MatchBetFilters);
